<div class="op-widget" [ngStyle]="containerStyle">
  <div class="op-widget__row">
    <div class="op-widget__main">
      @if (showLogo) {
        <img
          class="op-widget__logo"
          src="/assets/images/integrations/order_protection_mini.svg"
          alt="Order Protection" />
      }
      <div class="op-widget__text">
        <div class="op-widget__title-line">
          <span [ngStyle]="titleStyle">{{ titleText }}</span>
          @if (showInfoModal) {
            <pdq-icon
              class="op-widget__info"
              icon="more_information"
              size="small"
              color="var(--on-surface-light)"
              (click)="openInfoModal()"></pdq-icon>
          }
        </div>
        @if (subtitleText) {
          <span [ngStyle]="subtitleStyle">{{ subtitleText }}</span>
        }
      </div>
    </div>
    <div class="op-widget__action">
      <span class="op-widget__price">{{ priceLabel }}</span>
      @if (isCheckbox) {
        <span class="op-widget__checkbox" aria-hidden="true">&#10003;</span>
      } @else {
        <span class="op-widget__toggle" aria-hidden="true"><span class="op-widget__toggle-knob"></span></span>
      }
    </div>
  </div>
  @if (showDisclaimer) {
    <div class="op-widget__disclaimer" [ngStyle]="disclaimerStyle">{{ disclaimerText }}</div>
  }
</div>

@if (modalOpen) {
  <div class="op-modal-backdrop" (click)="closeInfoModal()">
    <div class="op-modal" (click)="$event.stopPropagation()">
      <div class="op-modal__header">
        <button type="button" class="op-modal__close" aria-label="Close" (click)="closeInfoModal()">
          <img src="/assets/icons/x.svg" alt="" />
        </button>
      </div>
      <div class="op-modal__heading">
        <span class="op-modal__eyebrow">Shipping Issues are over</span>
        <strong class="op-modal__title">Get shipping protection &amp; 24/7 support.</strong>
      </div>
      <pdq-divider></pdq-divider>
      <div class="op-modal__feature">
        <strong>Add shipping protection to your order.</strong>
      </div>
      <div class="op-modal__feature">
        <strong>Have a shipping issue? Let us know.</strong>
        <div class="op-modal__coverage">
          @for (item of coverageItems; track item) {
            <span class="op-modal__coverage-item">
              <span class="op-modal__check" aria-hidden="true">&#10003;</span>
              {{ item }}
            </span>
          }
        </div>
      </div>
      <div class="op-modal__feature">
        <strong>Get a resolution in as little as one hour. *</strong>
      </div>
      <p class="op-modal__footnote">
        * Contingent upon claim approval. In some cases, additional time may be required for investigation.
      </p>
      <div class="op-modal__footer">
        <span>2026 &copy; OrderProtection.com</span>
        <span class="op-modal__links">Terms &middot; Privacy Policy &middot; File a Claim</span>
      </div>
    </div>
  </div>
}
